import { render, staticRenderFns } from "@/modules/CertificateOfInsurance/templates/certificate-detail.html?vue&type=template&id=5517c74e&scoped=true&"
import script from "@/modules/CertificateOfInsurance/scripts/certificate-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/CertificateOfInsurance/scripts/certificate-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/CertificateOfInsurance/styles/certificate-detail.scss?vue&type=style&index=0&id=5517c74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5517c74e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
